// Types

export const VTreeviewSymbol = Symbol.for('vuetify:v-treeview');
//# sourceMappingURL=shared.js.map